// add an application source to local storage
const addApplicationSource = (key, name) => {
    if (!window.localStorage.applicationSource) {
        window.localStorage.applicationSource = JSON.stringify({});
    }
    let applicationSources = JSON.parse(window.localStorage.applicationSource);

    if (!applicationSources[key]) {
        applicationSources[key] = [];
    }
    // check if the source is already registered
    for (let i=0; i<applicationSources[key].length; i++) {
        if (applicationSources[key][i] == name) {
            return;
        }
    }
    applicationSources[key].push(name);

    window.localStorage.applicationSource = JSON.stringify(applicationSources);
};

const checkApplicationSources = () => {
    let classes = document.querySelector('body').className.split(' ');
    classes.forEach((className) => {
        if (className.startsWith('wp-item-')) {
            let pageId = className.substring(className.lastIndexOf('-')+1);
            addApplicationSource('wp-item', pageId);
        }
    });

    if (document.referrer) {
        let domain = (new URL(document.referrer)).hostname.replace('www.','');
        if (domain != location.hostname) {
            addApplicationSource('referrer', domain);
        }
    }

    let outputField = document.getElementById('application_sources_value');
    if (outputField && window.localStorage.applicationSource) {
        outputField.value = window.localStorage.applicationSource;
    }
};

window.addEventListener('DOMContentLoaded', checkApplicationSources);
window.checkApplicationSources = checkApplicationSources;